import React from 'react';

import { lensTokens } from '~/configs/unifiedAnalyticsTheme';

import { Chip } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';

import { FONT_STACK_SUISSE_INTL } from '~/components/brand/brandTokens';

export type SurfaceChipProps = {
  label: string;
  /** Compass-White-on-dark-field variant, for a chip sitting on a rail or dark band. */
  inverted?: boolean;
};

/**
 * The outlined hairline pill: the same visual formula as `BetaBadge` (src/pages/LeLens/BetaBadge.tsx),
 * generalised for any label rather than the fixed "Beta" text.
 */
export default function SurfaceChip({ inverted = false, label }: SurfaceChipProps) {
  const theme = useTheme();
  const tokens = lensTokens(theme);

  return (
    <Chip
      label={label}
      size="small"
      sx={{
        borderColor: inverted ? alpha(tokens.railText, 0.38) : alpha(tokens.accent, 0.28),
        color: inverted ? alpha(tokens.railText, 0.82) : 'text.secondary',
        flex: 'none',
        fontFamily: FONT_STACK_SUISSE_INTL,
        fontSize: '11px',
        height: 22,
        letterSpacing: '0.04em',
        lineHeight: 1,
        textTransform: 'uppercase',
        '& .MuiChip-label': { px: 1, py: 0 },
      }}
      variant="outlined"
    />
  );
}
